// used to map seo titles and descriptions to pages that are NOT day specific

export const seoTitleAndDescriptions = {
  replays: {
    titles: {
      "most-watched": () => "Most Watched Replays | Racing TV",
      "big-races": () => "Big Race Replays | Racing TV",
    },
    descriptions: {
      "most-watched": () =>
        "View the most watched horse racing replays in stunning HD with Racing TV. Catch up on all the latest racing action across the UK and Ireland.",
      "big-races": () =>
        "Watch racing replays from all the big races in stunning HD with Racing TV. Catch up on all the latest racing action across the UK and Ireland.",
    },
  },
  racecourse: {
    titles: {
      overview: (val) => `${val?.track} Racecourse, Results & Racecards`,
      results: (val) => `${val?.track} Racing Results | Racing TV`,
      racecards: (val) => `${val?.track} Racecards | Racing TV`,
      tips: (val) => `${val?.track} Tips | Racing TV`,
    },
    descriptions: {
      overview: (val) =>
        `${val?.track} racecourse details including upcoming races, full results, top winners, course maps, statistics and tickets.`,
      results: (val) =>
        `View all the latest horse racing results and video replays from ${val?.track} here. Plus get access to historic race results and replays. Read more.`,
      racecards: (val) =>
        `View all the latest horse racing racecards for ${val?.track}. Plus get access to all the latest form, odds, and statistics. Read more.`,
      tips: (val) =>
        `View all the latest horse racing tips for ${val?.track}. Plus get access to video tips and detailed jockey and trainer statistics. Read more.`,
    },
  },
  Racecourses: {
    titles: {
      "racing tv": () => `Horse Racing Racecourses | Racing TV`,
      uk: () => `UK Horse Racing Racecourses | Racing TV`,
      ireland: () => `Irish Horse Racing Racecourses | Racing TV`,
      international: () => `International Horse Racing Racecourses | Racing TV`,
    },
    descriptions: {
      "racing tv": () =>
        `Racecourse details to every racecourse in the UK, Ireland, and the top racecourses throughout the world. Contact details, full results, maps & tickets.`,
      uk: () =>
        `Racecourse details to every racecourse in the UK, including contact details, full results, maps & tickets.`,
      ireland: () =>
        `Racecourse details to every racecourse in Ireland, including contact details, full results, maps & tickets.`,
      international: () =>
        `Racecourse details to every major international racecourse, including contact details, full results, maps & tickets.`,
    },
  },
};
